import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Accordion, Button } from "react-bootstrap";
import logo from "../../../Assets/images/logo.png";
import s1 from "../../../Assets/images/sg1.png";
import s2 from "../../../Assets/images/sg2.png";
import { useUserPermissions } from "hooks/usePermissions";
import moduleConfig from "config/modules";

const SidebarNew = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const { hasPermission } = useUserPermissions();

  const handleSidebar = () => setSidebar(!sidebar);

  const CustomBox = ({ children, disabled = false }) => (
    <div className={`d-flex gap-2 px-3 align-items-center ${disabled ? 'text-muted' : ''}`}>{children}</div>
  );
  const CustomBoxOuter = ({ children, disabled = false }) => (
    <div className={`d-flex gap-2 align-items-center ${disabled ? 'text-muted' : ''}`}>{children}</div>
  );

  const isRouteActive = (path) => pageActive.includes(path);

  const firstActiveIndex = moduleConfig.findIndex((item) =>
    item.childLinks?.some((child) => isRouteActive(child.path))
  );

  return (
    <div className={`${styles.sidebar} ${sidebar && styles.active} sidebar position-fixed bg-white shadow-lg`}>
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0, zIndex: 99 }}
      >
        ✕
      </Button>

      <div className={`${styles.top} text-center px-3 position-relative`}>
        <img src={s2} alt="" className="position-absolute" style={{ left: 0, bottom: 0 }} />
        <img src={s1} alt="" className="position-absolute" style={{ right: 0, top: 0 }} />
        <Link to="/" className={styles.logo}>
          <img src={logo} alt="logo" className="img-fluid" />
        </Link>
      </div>

      <Accordion
        className={`${styles.linkWrpper} bg-white overflow-y-auto overflow-x-hidden`}
        alwaysOpen
        defaultActiveKey={firstActiveIndex !== -1 ? [firstActiveIndex.toString()] : []}
        style={{ height: "calc(100vh - 70px)" }}
      >
        <ul className="list-unstyled mb-0">
          {moduleConfig.map((item, index) => {
            const hasChildren = item.childLinks?.length > 0;
            const visibleChildren = hasChildren
              ? item.childLinks.filter(
                (child) =>
                  !child.permission ||
                  hasPermission(child.permission.module, child.permission.action)
              )
              : [];
            if (hasChildren && visibleChildren.length === 0) return null;
            const parentActive =
              hasChildren && visibleChildren.some((c) => isRouteActive(c.path));

            return (
              <li key={index}>
                {hasChildren ? (
                  <Accordion.Item
                    eventKey={index.toString()}
                    className={`${styles.accordionWrp} border-0 bg-transparent`}
                  >
                    <Accordion.Header
                      className={`${styles.accordionBtn} ${parentActive && styles.active}`}
                    >
                      {item.label}
                    </Accordion.Header>

                    <Accordion.Body className="p-0">
                      <ul className="list-unstyled mb-0">
                        {visibleChildren.map((child) => (
                          <li key={child.path}>
                            <NavLink
                              style={{ cursor: child?.isDisabled ? "not-allowed" : "pointer", backgroundColor: child?.isDisabled && "white" }}
                              to={child.path}
                              className={`${styles.subLinks} ${isRouteActive(child.path) && styles.active
                                } d-flex`}
                            >
                              <CustomBox disabled={child?.isDisabled}>{child.label}</CustomBox>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                ) : (
                  <NavLink
                    to={item.path}
                    style={{ cursor: item?.isDisabled ? "not-allowed" : "pointer", backgroundColor: item?.isDisabled && "white" }}
                    className={`${styles.link} ${isRouteActive(item.path) && styles.active
                      } d-flex`}
                  >
                    <CustomBoxOuter disabled={item?.isDisabled}>{item.label}</CustomBoxOuter>
                  </NavLink>
                )}
              </li>
            );
          })}
        </ul>
      </Accordion>
    </div>
  );
};

export default SidebarNew;
